import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../Axios/index";

// Get token from localStorage
const token = localStorage.getItem("token");

// Fetch User Details
export const fetchUser = createAsyncThunk("user/fetchUser", async (_, { rejectWithValue }) => {
  try {
    const response = await axios.get(`user/fetchUser`);
    return response.data.user;
  } catch (err) {
    return rejectWithValue(err.response.data);
  }
});

// Update User Details
export const updateUser = createAsyncThunk("user/updateUser", async (updatedData, { rejectWithValue }) => {
  try {
    const response = await axios.put(`user/updateUser`, updatedData);
    return response.data.user;
  } catch (err) {
    return rejectWithValue(err.response.data);
  }
});

export const updatePassword = createAsyncThunk(
  "user/updatePassword",
  async ({ email, updatedData }, { rejectWithValue }) => {
    try {
      const response = await axios.put(`user/updatePassword/?email=${email}`, updatedData);
      return response.data.user;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);


// Logout User
export const logoutUser = createAsyncThunk("user/logout", async () => {
  localStorage.removeItem("token");
  return null;
});

// User Slice
const userSlice = createSlice({
  name: "user",
  initialState: {
    user: null,
    token: token || null,
    status: "idle",
    error: null,
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Fetch User
      .addCase(fetchUser.pending, (state) => {
        state.status = "loading";
        state.loading = true;
      })
      .addCase(fetchUser.fulfilled, (state, action) => {
        state.user = action.payload;
        state.status = "succeeded";
        state.loading = false;
      })
      .addCase(fetchUser.rejected, (state, action) => {
        state.error = action.payload;
        state.status = "failed";
        state.loading = false;
        state.token = null;
      })
      // Update User
      .addCase(updateUser.pending, (state) => {
        state.status = "loading";
        state.loading = true;
      })
      .addCase(updateUser.fulfilled, (state, action) => {
        state.user = action.payload;
        state.status = "succeeded";
        state.loading = false;
      })
      .addCase(updateUser.rejected, (state, action) => {
        state.error = action.payload;
        state.status = "failed";
        state.loading = false;
      })
      //updatePassword
      .addCase(updatePassword.pending, (state) => {
        state.status = "loading";
        state.loading = true;
      })
      .addCase(updatePassword.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.loading = false;
      })
      .addCase(updatePassword.rejected, (state, action) => {
        state.error = action.payload;
        state.status = "failed";
        state.loading = false;
      })
      // Logout
      .addCase(logoutUser.fulfilled, (state) => {
        state.user = null;
        state.token = null;
        state.status = "idle";
        state.loading = false;
      });
      
  },
});

export default userSlice.reducer;
